import {Border, Borders} from 'exceljs';

/**
 * Auxiliary BorderStyleOptions interface declaration.
 */
interface BorderStyleOptions {
	/** {boolean} top */
	top?: boolean;
	/** {boolean} right */
	right?: boolean;
	/** {boolean} bottom */
	bottom?: boolean;
	/** {boolean} left */
	left?: boolean;
}

/** Auxiliary 'FULL_BORDER_OPTIONS' variable.' */
const FULL_BORDER_OPTIONS: BorderStyleOptions = {
	top: true,
	right: true,
	bottom: true,
	left: true,
};

/** Auxiliary 'COLORED_BORDERS' variable.' */
export const COLORED_BORDERS: {[side: string]: Border} = {
	BLACK: {style: 'thin', color: {argb: 'FF000000'}},
	DARK_GREY: {style: 'thin', color: {argb: 'FF808080'}},
	GREY: {style: 'thin', color: {argb: 'FFBFBFBF'}},
	WHITE: {style: 'thin', color: {argb: 'FFFFFFFF'}},
};

/**
 * 'ExcelBordersHelper' class definition.
 */
export class ExcelBordersHelper {
	/**
	 * Create borders.
	 * @param {Border} border
	 * @param {BorderStyleOptions} options
	 * @returns {Borders}
	 */
	public static createBorders(border: Border, options: BorderStyleOptions = FULL_BORDER_OPTIONS): Borders {
		return Object.keys(options).reduce((res, cur) => ({...res, [cur]: border}), {} as Borders);
	}

	/**
	 * Create border from hex.
	 * @param {string} hex
	 * @returns {Border}
	 */
	public static createBorderFromHex(hex: string): Border {
		return {style: 'thin', color: {argb: 'FF' + hex.replace('#', '')}};
	}
}
